<template>
  <div id="app">
    <div class="page-container">
      <header-custom></header-custom>
      <router-view/>
    </div>
    <footer-custom></footer-custom>
  </div>
</template>

<script>
import HeaderCustom from './components/Header'
import FooterCustom from './components/Footer'

export default {
  name: 'App',
  components: {
    HeaderCustom,
    FooterCustom
  }
}
</script>

<style lang="scss">
@import './styles/_fonts.scss';
@import './styles/_animations.scss';
@import './styles/_messages.scss';

body {
  margin: 0;
  padding: 0;
  background-color: $bg-color;
}
p {
  margin: 0;
}
#app {
  box-sizing: border-box;
  font-family: $primary-font;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $primary-color;
  position: relative;
  min-height: 100vh;
  .page-container {
    max-width: $max-width;
    margin: 0 auto;
    padding: $v-spacer $h-spacer $v-spacer-xl $h-spacer;
  }
}
.button {
  cursor: pointer;
  background-color: #fff;
  border: none;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  &:focus {
    outline: none;
  }
}
.return-button {
  position: absolute;
  left: 0;
  top: -90px;
  background-image: $primary-gradient;
  color: #fff;
  border-radius: $radius-sm;
  font-weight: 700;
  width: 160px;
  height: 54px;
  font-size: $text-size;
  font-family: $secondary-font;
  img {
    margin-right: 10px;
  }
}
.link {
  color: $primary-color;
}
</style>
